import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { AttributeMappingComponent } from 'src/app/modules/devices/attribute-mapping/attribute-mapping.component';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { EntitiesServiceService } from 'src/app/shared/services/entities-service.service';


@Component({
  selector: 'app-attribute-listing-modal',
  templateUrl: './attribute-listing-modal.component.html',
  styleUrls: ['./attribute-listing-modal.component.css']
})
export class AttributeListingModalComponent implements OnInit, OnDestroy {
  syncList: any[] = [];
  tableMasterData: any[] = [];
  columnHeader: any = { 'attribute': 'Attribute', 'action': 'Action' };
  private _afterClosedSubscription: Subscription;
  private _updateMappingDetialsSubscription: Subscription;
  private _syncConfigMessageSubscription: Subscription;

  constructor(
    public dialogRef: MatDialogRef<any>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sharedService: ServicecallService,
    private entityService: EntitiesServiceService
  ) { }

  ngOnInit(): void {
    this.tableMasterData = this.data?.details?.apiDetails?.attributes;
  }
  ngOnDestroy(): void {
    this._afterClosedSubscription?.unsubscribe();
    this._updateMappingDetialsSubscription?.unsubscribe();
    this._syncConfigMessageSubscription?.unsubscribe();
  }
  tableAction(event: any) {
    if (event) {
      let dialogRef = this.dialog.open(AttributeMappingComponent, {
        height: '90%',
        data: { msg: 'Edit attribute mapping', details: { apiDetails: event.item }, type: 'profile' },
        disableClose: true
      });
      this._afterClosedSubscription = dialogRef.afterClosed().subscribe(result => {
        if (result?.status) {
          this.data.details.apiDetails.attributes[event.index] = { ...result.value };
          this.tableMasterData = [... this.data?.details?.apiDetails?.attributes];
          this.syncList = this.sharedService.getConfiguration('syncInfo') ? this.sharedService.getConfiguration('syncInfo')?.syncInfo : [];
          this._updateMappingDetialsSubscription = this.entityService.updateMappingDetials(this.data?.details?.apiDetails).subscribe((res: any) => {
            if (res?.status === 200 || res?.status === 204) {
              this.getSync();
              this.dialogRef.close({ status: true, value: this?.data?.details?.apiDetails?.attributes });
            }
          });
        }
      });
    }
  }

  getSync() {
    this.syncList.forEach((item: any) => {
      this._syncConfigMessageSubscription = this.sharedService.syncConfigMessage(item).subscribe((res: any) => {
        if (res.status)
          this.sharedService.toasterService({ type: 'success', msg: res?.response?.message });
        else
          this.sharedService.toasterService({ type: 'error', msg: res?.response?.message });
      });
    });
  }

}
